import React, { useState } from 'react';
import AuthLayout from '../layout/AuthLayout';
import RightPanelTopMenu from '../component/molecule/common/RightPanelTopMenu';
import style from '../assets/styles/testCreationStyle.module.css';
import TestList from '../component/molecule/specific/TestCreationScreens/TestList';
import { useSelector } from 'react-redux';

const TestCreation = () => {
  const [organizationId, setOrganizationId] = useState(() => {
    const storedId = localStorage.getItem('selectedOrgId');
    return storedId ? Number(storedId) : null;
  });
  const { testScreen } = useSelector((state) => state.GetAllData);

  return (
    <AuthLayout>
      <RightPanelTopMenu
        title={'Test Templates and Test Papers'}
        setOrganisationId={(id) => setOrganizationId(id)}
        showOrgDropdown={true}
      />
      <div className={style.mainScreen}>
        {<TestList />}
        {/* {testScreen === 1 ? <AddTest /> : ''} */}
        {/* {testScreen === 2 ? <TestDetails /> : ''} */}
        {/* {testScreen === 3 ? <EditTest /> : ''} */}
      </div>
    </AuthLayout>
  );
};

export default TestCreation;
